import { isEmpty, range } from 'lodash';
// -- Local Storage Keys
export const LocalStorageKeys = {
    CURRENT_MONITORING_PERIOD: 'CURRENT_MONITORING_PERIOD',
    TAGS_SUB_PANEL_VIEW: 'TAGS_SUB_PANEL_VIEW',
    TAGS_SUB_PANEL_SORTING_BY: 'TAGS_SUB_PANEL_SORTING_BY',
    TAGS_SUB_PANEL_CARDS_DISPLAY_OPTIONS: 'TAGS_SUB_PANEL_DISPLAY_OPTIONS',
    TAGS_SUB_PANEL_CARDS_LAYOUT: 'TAGS_SUB_PANEL_CARDS_LAYOUT',
    TAGS_SUB_PANEL_HEAT_MAP_SCALE: 'TAGS_SUB_PANEL_HEAT_MAP_SCALE',
    TAGS_SUB_PANEL_CUSTOM_TAGS: 'TAGS_SUB_PANEL_CUSTOM_TAGS',
    HISTORY_TABLE_FILTER: 'HISTORY_TABLE_FILTER',
    PRESELECTED_VERSION_ID: 'PRESELECTED_VERSION_ID'
};
// -- custom tags selection persist
export const getStoredCustomTagsState = () => JSON.parse(localStorage.getItem(LocalStorageKeys.TAGS_SUB_PANEL_CUSTOM_TAGS));
export const setStoredCustomTagsInfo = (key, tagsParam, queueSize = 3) => {
    // local storage limits -- Reduce Tags to Tags Short Info
    const tags = tagsParam.map(({ name, description }) => ({ name, description }));
    try {
        const { state: currentStoredState, queue } = getStoredCustomTagsState() || {
            state: {},
            queue: []
        };
        let nextStoredState = {};
        let nextQueue = [];
        if (isEmpty(currentStoredState)) {
            // no entries
            if (!tags.length)
                return;
            nextQueue = [key];
            nextStoredState = { [key]: tags };
        }
        else if (currentStoredState[key]) {
            // existing entry
            if (!tags.length) {
                // remove
                delete currentStoredState[key];
                if (!isEmpty(currentStoredState)) {
                    nextQueue = queue.filter((el) => el !== key);
                    nextStoredState = currentStoredState;
                }
            }
            else {
                // update
                nextQueue = [...queue.filter((el) => el !== key), key];
                nextStoredState = { ...currentStoredState, [key]: tags };
            }
        }
        else if (queue.length < queueSize) {
            // new entry, queue has place
            nextStoredState = { ...currentStoredState, [key]: tags };
            nextQueue = [...queue, key];
        }
        else {
            // new entry, full queue
            const missingSlots = queue.length + 1 - queueSize;
            range(missingSlots).forEach((slotIndex) => {
                delete currentStoredState[queue[slotIndex]];
            });
            nextStoredState = { ...currentStoredState, [key]: tags };
            nextQueue = [...queue.slice(missingSlots), key];
        }
        localStorage.setItem(LocalStorageKeys.TAGS_SUB_PANEL_CUSTOM_TAGS, JSON.stringify({ state: nextStoredState, queue: nextQueue }));
    }
    catch (error) {
        console.error(error);
        // local storage limits -- Retry with smaller Queue size to fit
        const nextQueueSize = queueSize - 1;
        if (nextQueueSize)
            setStoredCustomTagsInfo(key, tags, nextQueueSize);
    }
};
export const getStoredCustomTagsInfo = (key) => {
    try {
        const { state: currentStoredState } = getStoredCustomTagsState() || { state: {} };
        return currentStoredState[key] || [];
    }
    catch (error) {
        return [];
    }
};
